import Box from '@mui/material/Box';
import * as React from 'react';
import _ from 'lodash';

import PartyButton from './PartyButton';

export default function PartyButtons({
    parties,
    isProcessing,
    onClick,
    currentParties,
    maxSelectedParties = 10,
    sx
}) {
    const partyLimitReached = currentParties?.length === maxSelectedParties;

    const getToolTipForParty = (party, isSelected) => {
        if (partyLimitReached && !isSelected) {
            return `Je kan maximaal ${maxSelectedParties} partijen vergelijken`;
        }
        return party.name;
    };

    return (
        <Box
            sx={{
                ...{
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                },
                ...sx
            }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
                {parties?.map(party => {
                    const isSelected = _.includes(
                        currentParties.map(p => p.uuid),
                        party.uuid
                    );

                    const isDisabled = (isProcessing || partyLimitReached) && !isSelected;

                    return (
                        <Box
                            key={party.uuid}
                            sx={{
                                flex: '1',
                                minWidth: {
                                    xs: 80,
                                    sm: 75
                                },
                                maxWidth: {
                                    xs: 80,
                                    sm: 75
                                }
                            }}>
                            <PartyButton
                                disabled={isDisabled}
                                tooltip={getToolTipForParty(party, isSelected)}
                                onClick={() => onClick(party)}
                                image={party.logo}
                                selected={isSelected}
                            />
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}
